import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewEncapsulation,
    input,
    output,
    inject,
} from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';
import { Observable } from 'rxjs';
import { MatSort, Sort } from '@angular/material/sort';
import { IAreaModel } from '@fi-app/area/area.model';
import { UserService } from '@fi-app/user/user.service';
import { IItemsListAction2 } from '@fi-shared/fi-items-list/fi-items-list';
import { ObjectTypes } from '@fi-shared/types';
import { AppTextService } from '@fi-shared/app-text';
import { ExtendSharingService } from '@fi-app/components/extend-sharing/extend-sharing.service';

@Component({
    selector: 'fi-area-list-wrapper-table',
    templateUrl: './area-list-wrapper-table.component.html',
    styleUrls: ['./area-list-wrapper-table.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-area-list-wrapper-table' },
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({ height: '0px', minHeight: '0', border: 'none' })),
            state('expanded', style({ height: '*' })),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    standalone: false,
})
export class FiAreaListWrapperTableComponent {
    @Input() isHeaderRowShown: boolean = true;
    public items = input<IAreaModel[]>([]);
    @Input() totalCount: number;
    public selectedItems = input<IAreaModel[]>([]);
    @Input() sortColumn: string;
    @Input() matSortDirection: 'desc' | 'asc';
    public loading = input<boolean>(false);
    @Input() onDataChanged$: Observable<void>;
    public matSortChange = output<Sort>();
    public checkedItemsChange = output<IAreaModel[]>();
    public scrollToBottom = output<void>();

    private userService = inject(UserService);
    private appTextService = inject(AppTextService);
    private extendSharingService = inject(ExtendSharingService);

    protected readonly listItemActions: IItemsListAction2[] = [
        {
            title: this.appTextService.get('sharing.extend_sharing_to'),
            onClick: (item) => {
                this.extendSharingService.openExtendedSharing(item.Id, ObjectTypes.Area);
            },
        },
    ];
    protected readonly hasAccessToExtendSharing: boolean = this.extendSharingService.hasAccessToExtendSharing();


    @ViewChild(MatSort, { static: false }) matSort: MatSort;

    protected onScrollToBottom(): void {
        // use setTimeout because of loading might not be finished in FiDataSourceBase
        setTimeout(() => this.scrollToBottom.emit());
    }

    protected openUserViewDialog($event: MouseEvent, itemChangedByUserId: number): void {
        $event.stopPropagation();
        this.userService.openUserViewDialog(itemChangedByUserId);
    }
    
    protected readonly FiStateNames = FiStateNames;
}
